import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Team.css";
import pavan from "../assets/pavan.jpg";
import manav from "../assets/manav.jpg";
import kush from "../assets/kush.jpg";
import logo from "../assets/logo.jpg";
import SEOHead from "./SEOHead";
import mrunal from "../assets/mrunal.jpg";
import jainil from "../assets/jainil.jpeg";
import fenil from "../assets/fenil.jpg";

const Team = () => {
  const navigate = useNavigate();

  const teamMembers = [
    {
      id: 1,
      name: "Pavan Rao",
      role: "Visionary Founder",
      type: "founder",
      location: "USA",
      bio: "Cybersecurity Expert & Tech Entrepreneur who founded ComLinkr based on real struggles as an international student.",
      expertise: ["Cybersecurity", "Business Strategy", "Product Vision", "Digital Innovation"],
      image: pavan,
      quote: "Leading with clarity, building with heart and purpose every step forward."
    },
    {
      id: 2,
      name: "Manav Trivedi",
      role: "Founder",
      type: "founder",
      location: "London, UK",
      bio: "Computer Science Graduate & Tech Innovator driving ComLinkr’s technical architecture and product development.",
      expertise: ["Computer Science", "Software Development", "Digital Innovation", "User Experience"],
      image: manav,
      quote: "Shaping global communities through technology and meaningful experiences."
    },
    {
      id: 4,
      name: "Kush Patel",
      role: "Database Developer",
      type: "team",
      location: "Vadodara, India",
      bio: "Student at Parul University with a focus on database systems and application support. Skilled in ensuring data integrity, optimizing queries, and providing effective coordination within development teams.",
      expertise: [
        "Database Management",
        "SQL & Query Optimization",
        "Data Modeling",
        "Problem Solving",
        "Team Coordination",
        "API Integration",
        "Testing & Debugging"
      ],
      image: kush,
      quote: "Focused on building reliable systems and contributing to collaborative success."
    },
        {
      id: 5,
      name: "Mrunal Shah",
      role: "Backend Developer",
      type: "team",
      location: "Ahmedabad, India",
      bio: "Final year student at Adani University with a strong foundation in backend development and a passion for creating scalable and efficient server-side applications.",
      expertise: [
        "Backend Development",
        "Database Modeling",
        "API Design & Integration",
        "AI Integration",
        "Deployment & DevOps",
        "Cloud Services",
        "Testing & Debugging"
      ],
      image: mrunal,
      quote: "Treat others like you want to be treated. Always ready to learn and grow with the team."
    },
            {
      id: 6,
      name: "Jainil Mathia",
      role: "Data Analyst",
      type: "team",
      location: "Ahmedabad, India",
      bio: "ICT student at Adani University with a strong foundation in data analysis and a passion for deriving meaningful insights from data. Experienced in analyzing datasets, creating interactive dashboards, and presenting data-driven insights to support informed decision-making.",
      expertise: [
        "Data Analysis",
        "Power BI & Dashboarding",
        "Trend & Pattern Analysis",
        "Data Visualization",
        "Business Insights & Reporting",
        "Python"
      ],
      image: jainil,
      quote: "Driven to transform data into insights that power smarter decisions."
    },
    {
      id: 7,
      name: "Fenil Mahesuriya",
      role: "Full Stack Development",
      type: "team",
      location: "Ahmedabad, India",
      bio: "ICT student at Adani University with hands-on experience across the full stack development. Passionate about building clean, efficient applications and integrating modern AI capabilities into real-world products.",
      expertise: [
        "Frontend Development",
        "Backend Development",
        "REST APIs",
        "Machine Learning",
        "AI Agents",
        "Database Management",
        "Version Control (Git)",
        "Problem Solving"
      ],
      image: fenil,
      quote: "Every line of code is a step towards building something that truly matters."
    }
  ];
  
  
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="team-container">
      <SEOHead
        title="Meet the Team — ComLinkr | The People Behind the Platform"
        description="Meet the ComLinkr team — the founders and builders creating a community-first platform for housing, food, and belonging worldwide."
        canonical="https://www.comlinkr.com/team"
      />
      <button className="team-back-btn" onClick={() => navigate('/')}>← Back to Home</button>
      {/* Header Section */}
      <section className="team-header">
        <div className="container text-center">
          <motion.div
            className="header-content"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <motion.img 
              src={logo} 
              alt="ComLinkr Logo" 
              className="team-logo"
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ duration: 1.2, type: "spring" }}
              onClick={() => navigate('/')}
            />
            
            <h1 className="team-title">
              Meet Our <span className="brand-highlight">Team</span>
            </h1>
            
            <p className="team-subtitle">
              Passionate individuals working together to create communities where everyone belongs
            </p>

            <div className="team-stats">
              <div className="stat-item">
                <div className="stat-number">7</div>
                <div className="stat-label">Team Members</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">2</div>
                <div className="stat-label">Founders</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">5+</div>
                <div className="stat-label">Years Combined Experience</div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="team-members-section">
        <div className="container">
          <motion.div
            className="team-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {/* Founders */}
            <div className="team-section-label" style={{ gridColumn: '1 / -1' }}><span>👑 Founders</span></div>
            {teamMembers.filter(m => m.type === 'founder').map((member) => (
              <motion.div
                key={member.id}
                className={`team-card ${member.type}`}
                variants={cardVariants}
                whileHover={{ y: -10, scale: 1.02, transition: { duration: 0.3 } }}
              >
                <div className="member-card-header">
                  <div className="member-image-container">
                    <img src={member.image} alt={member.name} className="member-image" />
                    <div className="member-role-badge">{member.type === 'founder' ? '👑' : '⭐'}</div>
                  </div>
                  <div className="member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-role">{member.role}</p>
                    <span className="member-location">📍 {member.location}</span>
                  </div>
                </div>
                <div className="member-card-body">
                  <p className="member-bio">{member.bio}</p>
                  {member.quote && (
                    <div className="member-quote">
                      <span className="quote-icon">"</span>
                      <p>{member.quote}</p>
                    </div>
                  )}
                  <div className="expertise-section">
                    <h5>Expertise</h5>
                    <div className="expertise-tags">
                      {member.expertise.map((skill, index) => (
                        <span key={index} className="expertise-tag">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}

            {/* Team */}
            <div className="team-section-label" style={{ gridColumn: '1 / -1' }}><span>⭐ Team</span></div>
            {teamMembers.filter(m => m.type === 'team').map((member) => (
              <motion.div
                key={member.id}
                className={`team-card ${member.type}`}
                variants={cardVariants}
                whileHover={{ y: -10, scale: 1.02, transition: { duration: 0.3 } }}
              >
                <div className="member-card-header">
                  <div className="member-image-container">
                    <img src={member.image} alt={member.name} className="member-image" />
                    <div className="member-role-badge">⭐</div>
                  </div>
                  <div className="member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-role">{member.role}</p>
                    <span className="member-location">📍 {member.location}</span>
                  </div>
                </div>
                <div className="member-card-body">
                  <p className="member-bio">{member.bio}</p>
                  {member.quote && (
                    <div className="member-quote">
                      <span className="quote-icon">"</span>
                      <p>{member.quote}</p>
                    </div>
                  )}
                  <div className="expertise-section">
                    <h5>Expertise</h5>
                    <div className="expertise-tags">
                      {member.expertise.map((skill, index) => (
                        <span key={index} className="expertise-tag">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Team Culture Section */}
      <section className="team-culture-section">
        <div className="container">
          <motion.div 
            className="culture-content"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="section-title">Our Team Culture</h2>
            
            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="culture-card">
                  <div className="culture-icon">🤝</div>
                  <h4>Collaboration First</h4>
                  <p>We believe the best solutions emerge when diverse perspectives unite with a common purpose.</p>
                </div>
              </div>
              
              <div className="col-lg-4 mb-4">
                <div className="culture-card">
                  <div className="culture-icon">🌍</div>
                  <h4>Global Mindset</h4>
                  <p>Our team brings international experience to build solutions that work across cultures and borders.</p>
                </div>
              </div>
              
              <div className="col-lg-4 mb-4">
                <div className="culture-card">
                  <div className="culture-icon">💡</div>
                  <h4>Innovation Focus</h4>
                  <p>We constantly push boundaries to create technology that makes a meaningful difference in people's lives.</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      
    </div>
  );
};

export default Team;